import {
  useCreateOrg,
  useGetOrganization,
  useGetOrganizations,
  useOnboardOrg,
  useUpdateBusiness,
  useUpdateOrg,
} from './hooks';

export const OrgService = {
  createOrg: () => {
    return useCreateOrg();
  },
  onboardOrg: () => {
    return useOnboardOrg();
  },
  updateOrg: () => {
    return useUpdateOrg();
  },
  updateBusiness: () => {
    return useUpdateBusiness();
  },
  getOrganizations: () => {
    return useGetOrganizations();
  },
  getOrganization: () => {
    return useGetOrganization();
  },
} as const;

export type {
  CreateOrganizationInput,
  Org,
  OrgResponse,
  UpdateOrganizationInput,
  UpdateOrgResponse,
} from './types';
